var _path, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _rect2, _path1, _path10, _circle, _circle2, _path11, _path12, _polygon, _path13, _polygon2, _path14, _path15, _path16, _path17, _path18, _circle3, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 760.16048,
    height: 561.13426,
    viewBox: "0 0 760.16048 561.13426",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M978.40083,213.99706H518.08511a1.2382,1.2382,0,0,1,0-2.47579H978.40083a1.2382,1.2382,0,0,1,0,2.47579Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#cacaca"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.42032,
    cy: 13.61683,
    rx: 13.31999,
    ry: 13.61683,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 371.43483,
    cy: 13.61683,
    rx: 13.31999,
    ry: 13.61683,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 417.44934,
    cy: 13.61683,
    rx: 13.31999,
    ry: 13.61683,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M950.83122,177.76185H918.1367a2.47639,2.47639,0,0,1,0-4.95158h32.69452a2.47639,2.47639,0,0,1,0,4.95158Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M950.83122,187.04606H918.1367a2.47639,2.47639,0,0,1,0-4.95158h32.69452a2.47639,2.47639,0,0,1,0,4.95158Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M950.83122,196.33026H918.1367a2.47639,2.47639,0,0,1,0-4.95158h32.69452a2.47639,2.47639,0,0,1,0,4.95158Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M978.86933,554.67449H518.55361a1.23819,1.23819,0,0,1,0-2.47578H978.86933a1.23819,1.23819,0,0,1,0,2.47578Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#cacaca"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M669.243,409.02321a12.01375,12.01375,0,0,1-12-12v-43a12,12,0,0,1,24,0v43A12.01375,12.01375,0,0,1,669.243,409.02321Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#ff7300"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M708.743,409.02321a12.01375,12.01375,0,0,1-12-12v-43a12,12,0,0,1,24,0v43A12.01375,12.01375,0,0,1,708.743,409.02321Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#ff7300"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M748.243,342.02321a12.00952,12.00952,0,0,0-12,12v43a12,12,0,1,0,24,0v-43A12.00952,12.00952,0,0,0,748.243,342.02321Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M787.743,342.02321a12.00952,12.00952,0,0,0-12,12v43a12,12,0,1,0,24,0v-43A12.00952,12.00952,0,0,0,787.743,342.02321Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#e6e6e6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M827.243,409.02321a12.01375,12.01375,0,0,1-12-12v-43a12,12,0,0,1,24,0v43A12.01375,12.01375,0,0,1,827.243,409.02321Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 380.32321,
    y: 248.09034,
    width: 296,
    height: 2,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 380.32321,
    y: 162.09034,
    width: 296,
    height: 2,
    fill: "#3f3d56"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M748.243,350.47323a12.00947,12.00947,0,0,0-12,12v34.55a12,12,0,1,0,24,0v-34.55A12.00948,12.00948,0,0,0,748.243,350.47323Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#ff7300"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M787.743,374.47323a12.00947,12.00947,0,0,0-12,12v10.55a12,12,0,1,0,24,0v-10.55A12.00948,12.00948,0,0,0,787.743,374.47323Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#ff7300"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 674.42303,
    cy: 206.09035,
    r: 11.99999,
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.42303,
    cy: 206.09035,
    r: 11.99999,
    fill: "#f2f2f2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M412.72184,445.43711a9.15749,9.15749,0,0,0-4.1246-13.42244L377.743,353.52321l-15.05333,10.05311L396.26386,437.468a9.20709,9.20709,0,0,0,16.458,7.96913Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#a0616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M376.08086,398.52273l-.18262-.125c-3.52929-2.418-5.02588-5.51075-5.23486-7.42432a3.22389,3.22389,0,0,1,.40869-2.16211l-6.32422-13.0581-25.74658-42.21241,14.69434-16.10791,2.94336-1.88965a3.43817,3.43817,0,0,1,2.78613-.25634c2.17822.66552,4.14941,3.1167,5.8584,7.28515.85742,2.09082,3.29883,7.06153,6.38916,13.3545,1.80517,3.67529,3.835,7.80859,5.91015,12.10205a6.98033,6.98033,0,0,1,.354,2.84521,6.68563,6.68563,0,0,0,.25732,2.43359c.187.39112.63477.5542,1.15381.74317a2.65659,2.65659,0,0,1,1.71729,1.25928c7.52343,15.92187,11.53808,25.95459,12.25683,30.62988a4.13234,4.13234,0,0,1,3.39356,3.93994,4.2885,4.2885,0,0,1-3.33838,4.53369Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#ff7300"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "37.492 475.736 44.909 483.909 79.966 459.188 69.018 447.124 37.492 475.736",
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M260.58862,637.42086l12.63029,12.3507-5.59463,5.07744,2.693,20.196a4.71923,4.71923,0,0,1-8.17255,3.7957l-14.10894-15.54609,3.102-7.702-6.48348,3.97612-5.31963-5.8615Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "125.13 540.421 136.167 540.421 141.42 497.848 125.13 497.848 125.13 540.421",
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M341.44728,702.29452l17.634-1.05251v7.55515l16.7651,11.57858a4.71923,4.71923,0,0,1-2.68163,8.60272l-20.99388,0-3.61862-7.47321-1.41288,7.47321h-7.91554Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M368.86943,690.323a13.02974,13.02974,0,0,1-1.30419-.06543l-38.14991-3.78906a12.83174,12.83174,0,0,1-11.29492-15.38672l22.17041-106.42188a539.98485,539.98485,0,0,1-23.812-83.05664c-8.78516-44.82226,8.14941-65.811,8.32129-66.01758l.09375-16.08691,9.13672-.52588,33.08105.10352.15235-3.67188,22.17285,57.60889-.0044.12012-3.498,101.15429,3.33252,8.19629L385.053,579.7781l-3.394,98.15332a12.83791,12.83791,0,0,1-12.78956,12.3916Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M323.69647,297.15629l15.56651-1.15308a6.92,6.92,0,0,1,7.36644,5.957l.75583,5.48855,14.35772,9.07445,16,39L374.72992,396.945l-3.98695-5.42182,2.32613,4.42159,2.67387,5.57841-4.44147,4-46.55853-4-20.26154-76.99212,9.284-7.65354,3.74036-14.5438A6.91994,6.91994,0,0,1,323.69647,297.15629Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#ff7300"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M292.74346,660.30349a6.94739,6.94739,0,0,1-2.44971-.45313,6.74193,6.74193,0,0,1-4.38281-5.55371l-4.74951-37.76855a6.88981,6.88981,0,0,1,1.97168-5.71485l9.144-9.00879,7.11572-2.68359,5.30908-9.70215L338.48369,555.908,379.304,585.70779l-82.05371,72.85449A6.75633,6.75633,0,0,1,292.74346,660.30349Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "be92b318-09a5-4c84-a1ba-69dfff500ca5-225",
    "data-name": "a1ca5f83-7fa1-45b1-9d3b-bf096f25c0e5",
    d: "M356.43022,283.34456l-1.99805-23.15446a31.14182,31.14182,0,0,0-62.05646,5.31484l.00344.03986c-4.48508,11.86714-.59652,16.9896,1.99805,23.15446a4.18834,4.18834,0,0,0,4.52535,3.80639l53.71921-4.63555A4.18837,4.18837,0,0,0,356.43022,283.34456Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "aa112140-1ac1-46a2-9314-ee7921cae26f",
    "data-name": "b14fd05a-a043-4ff7-820e-83dd0ca664c7",
    cx: 111.50711,
    cy: 96.99725,
    r: 22.83233,
    fill: "#a0616a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "ee3cfa53-3b94-464e-b31b-442dda2a3e33-226",
    "data-name": "b50f9c05-1494-4f26-bcdb-96e0065c79e8",
    d: "M361.93186,261.40851a24.66218,24.66218,0,0,0-26.661-22.42522l-4.63108.39962a24.66217,24.66217,0,0,0-22.42528,26.661l.04.46328c3.673,2.07179,6.99549,2.13444,9.7869-.84453l2.53112-9.63459,1.474,9.2889,5.05856-.43651,1.2793-4.86091.74419,4.68634c7.33458,5.22924,20.0138,1.3259,32.84321-2.83411Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M311.3303,462.73149a9.15745,9.15745,0,0,1-2.03055-13.89428l-3.736-83.04692,15.85557,1.53354,1.36071,81.1502a9.20709,9.20709,0,0,1-11.44977,14.25746Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#a0616a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M305.93486,408.449a4.31857,4.31857,0,0,1-3.97216-2.771,4.13245,4.13245,0,0,1,1.37548-5.01465c-1.187-3.95947-1.84765-12.59814-2.019-26.37012-.00488-.37646-.31445-.61181-.81982-.96484a2.25153,2.25153,0,0,1-1.25635-1.80225,8.17377,8.17377,0,0,1,1.06445-3.09033,8.01885,8.01885,0,0,0,.96582-2.646c.0044-6.90039.09375-13.64161.17285-19.58985.09278-7.01074.16651-12.54883.04444-14.80517-.24414-4.49854.48535-7.55811,2.16748-9.09375a3.44617,3.44617,0,0,1,2.62744-.96338l3.59473.478,20.05664,8.21582-5.15723,49.22363-.10986,14.46045a3.21942,3.21942,0,0,1,1.29638,1.77685c.63184,1.81836.60645,5.25391-1.54492,8.95215l-.11133.19141-17.3872,3.70556A4.71344,4.71344,0,0,1,305.93486,408.449Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#ff7300"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M451.23627,691.54633l16.11881-5.113a54.56112,54.56112,0,0,0-.3883-26.249c-6.47576,14.39869-25.47463,17.92647-36.29963,29.419a32.81868,32.81868,0,0,0-8.39531,27.17926l-3.39124,11.504a54.99375,54.99375,0,0,0,40.024-22.76717,53.12039,53.12039,0,0,0,6.22435-11.78347C458.25491,693.04775,451.23627,691.54633,451.23627,691.54633Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#f2f2f2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M434.01229,670.27382l12.14672-11.765A54.56121,54.56121,0,0,0,434.1049,635.188c.62546,15.77551-14.806,27.40615-19.36942,42.52016a32.81866,32.81866,0,0,0,4.60728,28.07074l2.09524,11.809a54.99377,54.99377,0,0,0,25.66946-38.22753,53.12075,53.12075,0,0,0,.31586-13.32265C440.96388,668.48747,434.01229,670.27382,434.01229,670.27382Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#f2f2f2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M502.5898,729.37713a1.18647,1.18647,0,0,1-1.19006,1.19h-280.29a1.19,1.19,0,0,1,0-2.38h280.29A1.18651,1.18651,0,0,1,502.5898,729.37713Z",
    transform: "translate(-219.91976 -169.43287)",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.40968894dfadc719a8a10dd9ad950f89.svg";
export { ForwardRef as ReactComponent };